<div class="mr-3">

  <h5 *ngIf="selectedFolder && !mediumGroup?.id" class="red font-weight-bold">
    {{ 'lang.mediumGroupEdit.folder'| translate : {folder: selectedFolder.name} }}
</h5>
  <form [formGroup]="form">
    <div class="form-group">
      <label class="form-label" for="Company">{{ 'lang.globals.company' | translate }}<span class="red">*</span></label>
      <button [disabled]="mediumGroup.company" (click)="selectCompany()" type="button" id="Company"
              class="btn btn-secondary text-center w-100">
        <sb-icon class="mr-1" icon="company"></sb-icon>
        {{ customer ? customer?.name : ('lang.globals.selectCompany' |translate) }}
      </button>
    </div>
    <div class="form-group validateMe">
      <label class="form-label" for="Title">{{ 'lang.globals.name' | translate }}<span class="red">*</span></label>
      <input type="text" id="Title" class="form-control" formControlName="Name">
      <span class="form-text text-muted">{{ 'lang.mediumGroupSettingsEdit.nameDescription' | translate }}</span>
      <div *ngIf="Name.touched && Name.errors?.required"
           class="alert alert-danger">{{ 'lang.mediumGroupSettingsEdit.nameWarning' | translate }}
      </div>
    </div>
    <div class="form-group validateMe">
      <label class="form-label" for="Description">{{ 'lang.globals.description' | translate }}</label>
      <input type="text" id="Description" class="form-control" formControlName="Description">
      <span class="form-text text-muted">{{ 'lang.mediumGroupSettingsEdit.description' | translate }}</span>
      <div *ngIf="Description.touched && Description.errors?.required"
           class="alert alert-danger">{{ 'lang.mediumGroupSettingsEdit.description' | translate }}
      </div>
    </div>
    <div class="d-flex justify-content-between">
      <button type="button" (click)="mediumGroupChangedEmitter.emit(null)"
              class="btn btn-default">{{ 'lang.globals.cancel' | translate }}
      </button>
      <button type="submit" (click)="updateMediumGroupCall()" [disabled]="!form.valid || !customer"
              class="btn btn-success">{{ 'lang.globals.submit' | translate }}
      </button>
    </div>
  </form>
</div>
